import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SelectMultiple } from 'grommet';

export const FilterOptionSelect = ({
    defaultValue,
    labelKey,
    options,
    placeholder,
    updateFormData,
    value,
    valueKey,
}) => {
    const [searchOptions, setSearchOptions] = useState(options);

    useEffect(() => {
        let isActive = true;

        if (isActive) {
            setSearchOptions(options);
        }

        return () => {
            isActive = false;
        };
    }, [options]);

    const filterOptions = (input) => {
        const lowercasedInput = input.toLowerCase();
        if (!labelKey) {
            return setSearchOptions(
                options.filter((option) =>
                    option.toString().toLowerCase().includes(lowercasedInput),
                ),
            );
        }
        setSearchOptions(
            options.filter((option) =>
                option[labelKey].toLowerCase().includes(lowercasedInput),
            ),
        );
    };

    const resetOptions = () => {
        setSearchOptions(options);
    };

    const handleChange = ({ value }) => {
        updateFormData(value);
    };

    return (
        <SelectMultiple
            key={labelKey}
            placeholder={placeholder}
            defaultValue={defaultValue}
            // help="Help text"
            // icon={<Key />}
            labelKey={labelKey} // how to retrieve the label for each option (can be string or function)
            valueKey={valueKey}
            // messages={{ multiple: "string" }} // ????
            // name="the name of the attribute when in a form/formfield"
            // onMore={() => {}} // used to lazy fetch more options
            // onOpen={() => {}}
            searchPlaceholder="Search options..."
            options={searchOptions || []}
            onChange={handleChange}
            onClose={resetOptions}
            onSearch={filterOptions}
            showSelectedInline={true}
            value={value}
        />
    );
};

FilterOptionSelect.propTypes = {
    defaultValue: PropTypes.array,
    labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    options: PropTypes.array,
    placeholder: PropTypes.string,
    updateFormData: PropTypes.func,
    value: PropTypes.array,
    valueKey: PropTypes.string,
};
